import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    refreshUrl: String
  }

  refresh() {
    const form = this.element

    form.action = this.refreshUrlValue
    form.method = "get"
    form.dataset.refreshing = "true"

    form.requestSubmit()
  }

  debouncedRefresh() {
    clearTimeout(this.debounceTimeout)
    this.debounceTimeout = setTimeout(() => {
      this.refresh()
    }, 1000)
  }
}

